import * as AccommodationService from '~/services/AccommodationService';

import { CatalogItemConfig } from '../types/catalogItem';

export const facilityConfig: CatalogItemConfig<
  AccommodationService.AdminFacility,
  AccommodationService.FacilityUpdatePayload,
  AccommodationService.FacilityCreatePayload,
  AccommodationService.ApproveFacilityPayload,
  AccommodationService.MergeFacilityPayload
> = {
  // Service methods
  listItems: async (params) => {
    const response = await AccommodationService.listFacilities({
      ...params,
      // AccommodationService.listFacilities expects a required literal union here.
      status: (params.status ?? 'approved') as 'approved' | 'draft',
    });
    return {
      ...response,
      result: {
        items: response.result.facilities,
        total: response.result.total,
      },
    };
  },
  updateItem: AccommodationService.updateFacility,
  createItem: AccommodationService.createFacility,
  deleteItem: AccommodationService.deleteFacility,
  approveItem: AccommodationService.approveFacility,
  discardItem: AccommodationService.discardFacility,
  mergeItem: AccommodationService.mergeFacility,
  createMergePayload: (sourceCode, targetCode) => ({
    sourceFacilityCode: sourceCode,
    targetFacilityCode: targetCode,
  }),

  // Query keys
  queryKeyPrefix: 'facilities',

  // Labels
  itemName: 'Facility',
  itemNamePlural: 'Facilities',

  // Type
  type: 'facility',
};
